import HeaderContact from '../../components/sections/HeaderContact'
import './contact.css'

const Contact = () => {
  return (
    <>
    <HeaderContact />
    </>
  )
}

export default Contact